export default __webpack_public_path__ + "static/media/redFlag.4f95afe9.png";